const Obrazy = () => {
  return (
    <div>Obrazy</div>
  )
}

export default Obrazy